// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zDGs","rootMobile":"styles_rootMobile__1cbvz"};